<template lang="pug">
main.pesquisa-inteligente-paraguay
    .pesquisa-inteligente-paraguay__barra-pesquisa
        i.el-icon-search

        input.pesquisa-inteligente-paraguay__input(
            v-model='filtro',
            type='text',
            :placeholder='$t("mensagens.home.pesquisaInteligente.placeholderParaguay")',
            autocomplete='off',
            @keyup.enter='realizarPesquisa',
            @blur='fecharLista'
        )

    transition(name='el-zoom-in-top')
        ul.pesquisa-inteligente-paraguay__ul(v-show='mostrarLista')
            .mb-2(v-for='opcao in opcoes')
                span.pesquisa-inteligente-paraguay__categoria(
                    v-if='opcao.resultado.length'
                ) {{ opcao.categoria }}

                li(v-for='resultado in opcao.resultado')
                    span(@click='mapearAcao(resultado.id, opcao.codigo)') {{ resultado.valor }}

            .mb-2.pesquisa-inteligente-paraguay__cadastro
                el-button.pesquisa-inteligente-paraguay__btn-cadastro(
                    icon='el-icon-plus',
                    @click='cadastrarRepresentante',
                    size='mini'
                )
                    | {{ $t('mensagens.home.pesquisaInteligente.cadastrarPessoa') }}

                el-button.pesquisa-inteligente-paraguay__btn-cadastro(
                    icon='el-icon-plus',
                    @click='cadastrarTerritorio',
                    size='mini'
                )
                    | {{ $t('mensagens.home.pesquisaInteligente.cadastrarTerritorio') }}

    ModalDiagnosticoSocioambientalRepresentante(
        confirmar,
        :mostrar='mostrarModalDiagnosticoSocioambiental',
        :dadosRepresentante='representante',
        @fechar='mostrarModalDiagnosticoSocioambiental = false'
    )
</template>

<script>
import PesquisaInteligenteService from '@/services/PesquisaInteligenteService';
import RepresentanteService from '@/services/RepresentanteService';

import formatters from '@/utils/formatters';

import ModalDiagnosticoSocioambientalRepresentante from '@/components/ModalDiagnosticoSocioambientalRepresentante.vue';

export default {
    name: 'PesquisaInteligenteParaguay',

    components: {
        ModalDiagnosticoSocioambientalRepresentante
    },

    data() {
        return {
            filtro: '',
            opcoes: [],
            mostrarLista: false,
            representante: {},
            mostrarModalDiagnosticoSocioambiental: false
        };
    },

    methods: {
        async realizarPesquisa() {
            if (!this.filtro) return this.limpar();

            const { data } =
                await PesquisaInteligenteService.realizarPesquisaHomeParaguay(
                    this.filtro
                );
            this.opcoes = data;
            this.mostrarLista = true;

            const semResultado = !this.opcoes.filter(
                ({ resultado }) => resultado.length
            ).length;
            if (semResultado) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.operacao.notificacao.semResultadosTextoInformado1'
                    )
                });
            }
        },

        limpar() {
            this.items = [];
            this.filtro = '';
            this.mostrarLista = false;
        },

        fecharLista() {
            setTimeout(() => {
                this.mostrarLista = false;
            }, 300);
        },

        mapearAcao(id, tipo) {
            this.mostrarLista = false;
            switch (tipo) {
                case 'REPRESENTANTE':
                    this.realizarDiagnosticoSocioambientalRepresentante(id);
                    break;
                case 'TERRITORIO':
                    this.visualizarTerritorio(id);
                    break;
                case 'CAR':
                    this.realizarDiagnosticoSocioambientalCAR(id);
                    break;
                case 'MUNICIPIO':
                    this.visualizarMunicipio(id);
                    break;
            }
        },

        async realizarDiagnosticoSocioambientalRepresentante(id) {
            await this.buscarRepresentante(id);
            this.mostrarModalDiagnosticoSocioambiental = true;
        },

        async buscarRepresentante(id) {
            const { data } = await RepresentanteService.findById(id);

            this.representante = {
                nome: data.nomeRazaoSocial,
                cpfCnpj: formatters.numeralStringFormatTocpfCnpj(data.cpfCnpj),
                email: data.email
            };
        },

        realizarDiagnosticoSocioambientalCAR(car) {
            this.$router.push({
                name: 'DiagnosticoSocioambiental',
                params: { pesquisa: car }
            });
        },

        visualizarTerritorio(id) {
            this.$router.push({
                name: 'VisualizarTerritorio',
                params: { idTerritorio: id }
            });
        },

        visualizarMunicipio(id) {
            this.$router.push({ name: 'SIG', params: { idMunicipio: id } });
        },

        cadastrarRepresentante() {
            this.$router.push({
                name: 'Pessoa',
                params: { cadastrar: this.filtro }
            });
        },

        cadastrarTerritorio() {
            this.$router.push({
                name: 'CadastrarEditarTerritorio',
                params: { cadastrar: this.filtro }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.pesquisa-inteligente-paraguay {
    width: 100%;
    height: 46px;
    border-radius: 5px;
    background: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

.pesquisa-inteligente-paraguay__input {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    border-radius: 5px;
    color: var(--primary);
}

.pesquisa-inteligente-paraguay__barra-pesquisa {
    height: 100%;
    display: flex;
    justify-content: center;

    i.el-icon-search {
        color: var(--gray);
        font-size: 16px;
        display: flex;
        align-items: center;
        margin: 0 8px;
    }
}

.pesquisa-inteligente-paraguay__ul {
    list-style: none;
    padding: 8px 0 8px 24px;
    position: relative;
    z-index: 42;
    margin-top: 5px;
    border-radius: 5px;
    background-color: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

    li {
        padding-left: 18px;
        margin-top: 5px;
        cursor: pointer;
    }
}

.pesquisa-inteligente-paraguay__categoria {
    font-weight: bold;
}

.pesquisa-inteligente-paraguay__cadastro {
    display: flex;
}

.pesquisa-inteligente-paraguay__btn-cadastro {
    border-radius: 20px !important;
}

em {
    background-color: var(--secondary);
}
</style>
